import type { EduForm, EduProofFile } from '../../store/eduSlice';

const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
const MAX_FILE_SIZE = 4 * 1024 * 1024;

const REQUIRED_TEXT_FIELDS = [
  'expectedGraduationDate',
  'institutionName',
  'institutionCity',
  'institutionCountry',
] as const;

const notEmpty = (value: string): boolean => Boolean(value?.trim());

/** Message key for any required text/date field left empty. */
export function validateEduTextField(value: string): string | null {
  return notEmpty(value) ? null : 'Field cannot be empty.';
}

export function validateEduProofFile(file: EduProofFile | null): string | null {
  if (!file || file.size <= 0) return 'File cannot be empty.';
  if (!ALLOWED_FILE_TYPES.includes(file.type)) {
    return 'Please upload only jpeg, png or pdf file.';
  }
  if (file.size >= MAX_FILE_SIZE) {
    return 'File cannot be larger than 4 megabytes.';
  }
  return null;
}

/** `notes` is the only optional field, so it is excluded here on purpose. */
export function isEduFormValid(
  form: EduForm,
  errors: Record<string, string | null>,
): boolean {
  const textFieldsValid = REQUIRED_TEXT_FIELDS.every(
    (field) => notEmpty(form[field]) && !errors[field],
  );
  return (
    textFieldsValid &&
    !errors.imageProof &&
    validateEduProofFile(form.imageProof) === null
  );
}
